import type { Capability } from "owa-capabilities";
import type { MailboxInfo } from "owa-client-types";
import { isMonarchMultipleAccountsEnabled } from "owa-account-source-list";
import { isAccountExplicitLogon } from "owa-account-shared-mailbox-utils";
import { isUnifiedInboxMailboxInfo } from "owa-client-types/lib/UnifiedInboxMailboxInfo";

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 * This capability is being used to determine if the outlook favorites UI should be enabled
 */
export const favoritesCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return true; // by default
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        if (mailboxInfo) {
            if (isMonarchMultipleAccountsEnabled()) {
                if (isUnifiedInboxMailboxInfo(mailboxInfo)) {
                    // Unified Inbox mailboxes are virtual folders, thus we don't support favorites
                    return false;
                }
                return true;
            }
            else {
                // OWA Favorites support logic
                return mailboxInfo?.type === "UserMailbox" && !isAccountExplicitLogon(mailboxInfo);
            }
        }
        return false;
    },
};
